/**
 * ���������, �������� �� ���������� ��������� (� ���������� ������� touchstart).
 * @returns {boolean} - ���������� true, ���� ���������� ���������, � ��������� ������ ���������� false.
 */
export default function isTouchDevice() {
    // ��������� ������� ������� touchstart � ������� window ��� ��������� ������������� ���������� ����� �������������
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}
